import { create } from 'zustand';

// eslint-disable-next-line import/prefer-default-export
export const useUnsubscribeStore = create(setState => ({
  resubscribed: false,
  setResubscribed: () => setState({ resubscribed: true }),
  currentToken: null,
  setCurrentToken: token => setState({ currentToken: token }),
  currentEmailTypeId: null,
  setCurrentEmailTypeId: emailTypeId =>
    setState({ currentEmailTypeId: emailTypeId }),
}));
